import { Typography } from "@mui/material";

import BasicButton from "../../../ui library/components/buttons/BasicButton";

export default function DeleteReferralDialogue({ title, onClickDelete }) {
  return (
    <div className="flex h-full w-full flex-col items-center p-2">
      <div className="p-4">
        <Typography className="text-lg font-bold text-red-600">{title}</Typography>
      </div>
      <div className="p-4">
        <Typography className="text-normal text-black">
          Are you sure you want to delete the selected referrals?
        </Typography>
      </div>
      <div className="flex flex-row gap-2">
        <BasicButton
          disabled={false}
          text="Proceed to Delete"
          className={`bg-red-600 hover:bg-red-700`}
          onClick={onClickDelete}
        />
      </div>
    </div>
  );
}
